import React from "react";

import { ReactComponent as CerebroIcon } from "root/entities/Buttons/Custom/Cerebro/elements.svg";

import MonitoringHomePageIcon from "root/icons/MonitoringHomePage";

// ---------------------------------------------------------------
const competitorAnalysisSections = {
  type: "section",
  title: "Анализ конкурентов",
  icon: MonitoringHomePageIcon,
  expanded: true,
  children: [
    {
      url: "/search/product",
      component: React.lazy(() => import("root/pages/search/components/Product")),
      title: "Анализ артикула",
      endIcon: CerebroIcon,
      endIconTooltip: "Раздел поддерживает «ЦЕРЕБРО»",
      exact: false,
    },
    {
      url: "/search/brand",
      component: React.lazy(() => import("root/pages/search/components/Brand")),
      title: "Анализ бренда",
      exact: false,
    },
    {
      url: "/search/seller",
      component: React.lazy(() => import("root/pages/search/components/Seller")),
      title: "Анализ поставщика",
      endIcon: CerebroIcon,
      endIconTooltip: "Раздел поддерживает «ЦЕРЕБРО»",
      exact: false,
    },
    {
      url: "/search/category",
      component: React.lazy(() => import("root/pages/search/components/Category")),
      title: "Анализ категорий",
      exact: false,
    },
    {
      url: "/analysis-by-subject",
      component: React.lazy(() => import("root/pages/analysis-by-subject/App")),
      title: "Анализ предметов",
    },
    {
      url: "/analysis-by-characteristics",
      component: React.lazy(() => import("root/pages/analysis-by-characteristics/App")),
      title: "Анализ характеристик",
      exact: false,
    },
    {
      url: "/analysis-by-seasonality",
      component: React.lazy(() => import("root/pages/analysis-by-seasonality/App")),
      title: "Анализ сезонности",
      exact: false,
    },
    {
      title: "Аналитика СПП",
      url: "/spp_by_subjects",
      component: React.lazy(() => import("root/pages/spp_by_subjects/App")),
      exact: false,
    },
    {
      url: "/search-tops-analysis",
      component: React.lazy(() => import("root/pages/search-tops-analysis/App")),
      title: "Анализ топов поиска",
      endIcon: CerebroIcon,
      endIconTooltip: "Раздел поддерживает «ЦЕРЕБРО»",
      exact: false,
    },
    {
      title: "Сравнительный анализ",
      url: "/articles-comparison",
      component: React.lazy(() => import("root/pages/articles-comparison/App")),
      exact: false,
    },
    {
      url: "/geo-size-location",
      component: React.lazy(() => import("root/pages/geo-location/App")),
      title: "ГЕО Видимость",
      exact: false,
    },
    {
      url: "/brands-rating",
      component: React.lazy(() => import("root/pages/brands-rating/App")),
      title: "Рейтинг брендов",
      onlyInDev: true,
      onlyForAdmin: true,
      exact: false,
    },
    {
      url: "/sellers-rating",
      component: React.lazy(() => import("root/pages/sellers_rating/App")),
      title: "Рейтинг поставщиков",
      onlyInDev: true,
      onlyForAdmin: true,
      exact: false,
    },
    {
      url: "/external-traffic",
      component: React.lazy(() => import("root/pages/external-traffic/App")),
      title: "Частотность артикула",
      exact: false,
    },
  ],
};

export default competitorAnalysisSections;
